var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-page-layout"},[_c('SiteHeader'),_c('main',{staticClass:"content-page-layout__body"},[_vm._t("default")],2),_c('TemplateFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }